import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private sessionId: string | null = null;

  constructor() {
    this.loadSession();
  }

  private loadSession() {
    const savedSessionId = sessionStorage.getItem('sessionId');
    if (savedSessionId) {
      this.sessionId = savedSessionId;
    } else {
      this.generateNewSession();
    }
  }

  private generateNewSession() {
    this.sessionId = uuidv4();
    sessionStorage.setItem('sessionId', this.sessionId);
  }

  public getSessionId(): string {
    return this.sessionId ?? 'defaultSessionId';
  }

  public resetSession() {
    this.generateNewSession();
  }
}
